var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataCard',{attrs:{"title":"Stake Statistics","data":_vm.stakeStatsArray,"min-width":"500","fullheight":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }